import {
  LOADER_STATUS,
  TABLE_DATA,
  TOTAL_RECORDS,
  TOTAL_PAGES,
  EWAY_RES_TABLE_DATA,
  EWAY_ITEM_ERROR_DATA,
  GENERATE_PART_B_DATA,
  TRANSPORTER_ID_DATA,
  UPDATE_VEHICLE_DATA,
  EXTEND_VALIDITY,
} from "./constants";

export const initialState = {
  loaderStatus: false,
  tableData: [],
  totalPages: 1,
  totalRecords: 1,
  ewayResTableData: [],
  ewayItemErrorData: [],

  // Generate part B states
  generatePartB: {
    transportMode: "",
    transportDocNo: "",
    transportDocDate: "",
    txn_id: "",
    transportNo: "",
    transportDistance: "",
    vehicleNo: "",
    vehicleType: "",
    transportId: "",
  },

  // update transporter ID states
  transporterIdData: {
    EwbNo: "",
    Supplier_GSTIN: "",
    audit_type: "transporterId",
    file_id: "",
    transporterId: "",
    txn_id: "",
  },

  // update vehicle no states
  updateVehicleData: {
    vehicleNoTransDate: "",
    txn_id: "",
    updateFromPlace: "",
    updateFromState: "",
    updateTransportMode: "",
    updateVehicleNo: "",
    reasonCode: "",
    reasonRem: "",
    audit_type: "updateVehicleNumber",
    file_id: "",
    Supplier_GSTIN: "",
    EwbNo: "",
    updateTransportDoc: "",
  },

  // update extend validity states
  updateExtendValidityData: {
    TransDate: "",
    txn_id: "",
    audit_type: "extendValidity",
    Consignment: "",
    TransportMode: "",
    extReasonCode: "",
    extension: "",
    fromPinCode: "",
    fromPlace: "",
    fromState: "",
    remainingDistance: "",
    transitType: "",
    vehicleNo: "",
    file_id: "",
    Supplier_GSTIN: "",
    EwbNo: "",
    address1: "",
    address2: "",
    address3: "",
    transportDocNo: "",
  },
};

/* eslint-disable default-case, no-param-reassign */
const EwayBillReducerNew = (state = initialState, action) => {
  switch (action.type) {
    case LOADER_STATUS:
      return {
        ...state,
        loaderStatus: action.loaderStatus,
      };
    case TABLE_DATA:
      return {
        ...state,
        tableData: action.tableData,
      };
    case TOTAL_PAGES:
      return {
        ...state,
        totalPages: action.totalPages,
      };
    case TOTAL_RECORDS:
      return {
        ...state,
        totalRecords: action.totalRecords,
      };
    case EWAY_RES_TABLE_DATA:
      return {
        ...state,
        ewayResTableData: action.ewayResTableData,
      };
    case EWAY_ITEM_ERROR_DATA:
      return {
        ...state,
        ewayItemErrorData: action.ewayItemErrorData,
      };
    case GENERATE_PART_B_DATA:
      return {
        ...state,
        generatePartB: { ...action.payload },
      };
    case TRANSPORTER_ID_DATA:
      return {
        ...state,
        transporterIdData: { ...action.payload },
      };
    case UPDATE_VEHICLE_DATA:
      return {
        ...state,
        updateVehicleData: { ...action.payload },
      };
    case EXTEND_VALIDITY:
      return {
        ...state,
        updateExtendValidityData: { ...action.payload },
      };
    default:
      return state;
  }
};

export default EwayBillReducerNew;
